import { LANGUAGE, type SupportedLocale } from '@/shared/localization';

/**
 * 로케일별로 노출하지 않는 detail 톤.
 *
 * 백엔드 meta(`detail.tones`)는 로케일 구분 없이 전체 톤을 내려주므로,
 * 특정 언어에서 지원하지 않는 톤은 프론트에서 의도적으로 제외한다.
 * soft 톤은 영어 상세 생성에서 미지원이라 en 에서 숨긴다.
 *
 * 톤 키는 i18n 경로에 그대로 이어붙는 접두 형식(`tone.soft`)이라
 * 마지막 dot-세그먼트로 비교한다(bare `soft` 도 동일하게 걸린다).
 */
const EXCLUDED_TONES_BY_LOCALE: Record<SupportedLocale, readonly string[]> = {
  [LANGUAGE.KO]: [],
  [LANGUAGE.EN]: ['soft'],
};

function toneKeyOf(tone: string): string {
  const segments = tone.split('.');
  return segments[segments.length - 1];
}

export function filterDetailTonesByLocale(
  tones: string[],
  locale: SupportedLocale,
): string[] {
  const excluded = EXCLUDED_TONES_BY_LOCALE[locale];
  return tones.filter((tone) => !excluded.includes(toneKeyOf(tone)));
}
